<template>
  <v-app-bar v-if="customizer.headerBar" :color="isDark ? '' : customizer.navbarColor" elevation="5"
    :priority="priority" :class="[
      'v-topbar px-4',
      customizer.navbarColor == '#ffffff' ? '' : 'text-white',
    ]">
    <!-- ---------------------------------------------- -->
    <!---Logo part -->
    <!-- ---------------------------------------------- -->
    <div class="p-4 pl-1">
      <MiscDYLink to="/">
        <img
          :src="windowStore.windowWidth > 500 ? `${domain}/renewal/img/logo_transparent.png` : `${domain}/doyacimpl/mini_logo.svg`"
          class="h-10">
      </MiscDYLink>
      <LcFullLogoDark v-if="!isDark && customizer.navbarColor == '#ffffff'" />
      <LcFullLogoLight v-else />
    </div>

    <!-- 큰 화면일 때 -->
    <v-app-bar-nav-icon color="lighten-2" class="!hidden md:!block !w-9 !h-9"
      @click.stop="adminMainStore.personalSetting.miniSideBar = !adminMainStore.personalSetting.miniSideBar" />

    <!-- 작은 화면일 때 -->
    <v-app-bar-nav-icon color="lighten-2" class="md:!hidden !w-9 !h-9" @click.stop="customizer.SET_SIDEBAR_DRAWER" />
    <template v-if="isAdmin">
      <v-btn v-if="siteName !== '도약닷컴'" class="mr-2 text-white hidden xl:!flex" href="https://creator.doyac.com/"
        target="_blank">닷컴 관리자</v-btn>
      <v-btn v-if="siteName !== '도약아트'" class="mr-2 text-white hidden xl:!flex" href="https://creator.doyacart.com/"
        target="_blank">아트 관리자</v-btn>
      <v-btn v-if="siteName !== '마이퍼스트가이드'" class="mr-2 text-white hidden xl:!flex"
        href="https://creator.myfirstguide.com/" target="_blank">마퍼가 관리자</v-btn>
    </template>
    <div class="grow"></div>
    <v-btn v-if="isAdmin" class="mr-5 text-white" prepend-icon="fa-arrow-right" :href="oldUrl"
      target="_blank">(구)관리자</v-btn>
    <DYLogoutLink v-slot="{ requestLogout }">
      <v-btn class="mr-5 text-white" prepend-icon="fa-sign-out" @click="clickLogout">로그아웃</v-btn>
    </DYLogoutLink>
    <v-btn class="text-white" prepend-icon="fa-laptop" @click="openSite">사이트 이동</v-btn>
    <v-app-bar-nav-icon v-if="isAdmin"
      :color="adminMainStore.pageHelpMemoNavSettings.hasPageMemos ? 'amber' : 'lighten-2'" icon="fas fa-circle-question"
      @click="adminMainStore.openPageHelpMemoNav('main')"
      :class="adminMainStore.pageHelpMemoNavSettings.hasPageMemos ? 'animate-spin' : undefined" />
  </v-app-bar>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faBell, faCircleQuestion, faMessage, faSearch, faSignOut, faLaptop, faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import { useCustomizerStore } from "~~/modules/nuxt3-module-admin-doyac/stores/customizer";
import { message, notification, profile } from "./data";
import { getFullDomain } from "~~/modules/nuxt3-module-doyac/libs/utils";
import { useDYAppConfig } from "~~/modules/nuxt3-module-doyac/composables/config";
import { useDark, useToggle } from "@vueuse/core";
import { useDYAdminMainStore } from "~/modules/nuxt3-module-admin-doyac/stores/main";
import { useDYWindowStore } from "~/modules/nuxt3-module-doyac/stores/window";
import { useDYAuth } from "~/modules/nuxt3-module-doyac/composables/auth";
import { $dy__fetchWithToken } from "~/modules/nuxt3-module-doyac/composables/fetch";
const { siteName } = useDYAppConfig()

library.add(faBars, faBell, faCircleQuestion, faMessage, faSearch, faSignOut, faLaptop, faArrowRight)

const { domain: dom, protocol, basePath: configBasePath } = useDYAppConfig()
const { isTeacher, isAdmin, isPartner } = useDYAuth()

const isDark = useDark()
const toggleDark = useToggle(isDark)
const customizer = useCustomizerStore()
const adminMainStore = useDYAdminMainStore()
const windowStore = useDYWindowStore()
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const showSearch = ref(false);
const href = ref(undefined);
const messages = ref(message);
const notifications = ref(notification);
const userprofile = ref(profile);
const priority = ref(customizer.setHorizontalLayout ? 0 : 0);

const domain = getFullDomain({ protocol, domain: dom })

const oldUrl = computed(() => {
  if (isAdmin.value) return `${domain}/apple`
  if (isTeacher.value) return `${domain}/teacher`
  if (isPartner.value) return `${domain}/partner`
  return ''
})

const _saveCurrentUrl = () => {
  const redirect = useCookie('auth.redirect')
  redirect.value = route.fullPath

  // 이전 페이지를 기록할 때 basePath도 기록해야 함. basePath는 관리자 앱이냐 일반 유저 앱이냐에 따라 달라지는데
  // 로그인 성공 후 이동되는 URL에는 기본적으로 basePath가 포함되지 않기 때문에 이전 페이지가 어디서 왔는지 알기
  // 위해서 필요함.
  const basePath = useCookie('auth.basePath')
  basePath.value = configBasePath
}

const clickLogout = async () => {
  await userStore.requestLogout();
  _saveCurrentUrl()
  router.push('/login')
}

// creator.* 도메인 → www.* 도메인은 cross-domain이므로 세션 쿠키가 전달되지 않아 관리자 권한 없이 열림.
// Bearer 토큰으로 일회용 티켓을 발급받아 forceLoginUsingId v2 방식으로 본인 계정 토큰을 세팅 후 이동.
const openSite = () => {
  window.open(domain, '_blank')
}

function searchbox() {
  showSearch.value = !showSearch.value;
}
watch(priority, (newPriority) => {
  // yes, console.log() is a side effect
  priority.value = newPriority;
});
</script>

<style scoped>
.v-topbar :deep(.v-toolbar__content) {
  display: flex;
}
</style>